export default "__VITE_ASSET__Bbvo6Yir__"